// React
import { ReactElement } from 'react';
// Modules
import { MixedCheckbox } from '@reach/checkbox';
import VisuallyHidden from '@reach/visually-hidden';
// Interface
import { NationalityFilterProps } from '@utmb/types/runner-ranking-table';
import { IconsEnum } from '@utmb/types/icons';
// Design System
import { DropDown, DropDownItem } from '@utmb/design-system/dropdown/Dropdown';
import { Font } from '@utmb/design-system/text/font';
import { Icon } from '@utmb/design-system/icons/Icon';
import { Separator } from '@utmb/design-system/separator/Separator';
// Utils
import { rem } from '@utmb/utils/font';
// Styles
import styles from './filters.module.scss';
import { useTranslation } from 'next-i18next';
import { Flag } from '@utmb/design-system/flag/Flag';

const NationalityFilter = (props: NationalityFilterProps): ReactElement => {
    const { currentNationality, nationalities, setCurrentNationality, query, fetchData } = props;
    const { t } = useTranslation();
    const handleInputNationalityChange = (nationality: any): void => {
        if (nationality !== currentNationality) {
            setCurrentNationality(nationality);
            query.nationality = nationality;
            fetchData(query);
        } else {
            setCurrentNationality('');
            query.nationality = '';
            fetchData(query);
        }
    };

    return (
        <div className={styles.toolbar}>
            <DropDown
                className={styles.drop}
                button={({ isExpanded }) => (
                    <>
                        <Font.FuturaHeavy mobile="14" desktop="16">
                            {t('performanceTable.nationality')}
                        </Font.FuturaHeavy>
                        <Icon color={'var(--utmb-color-ws-primary)'} variant={IconsEnum[isExpanded ? 'CHEVRON_UP' : 'CHEVRON_DOWN']} />
                    </>
                )}
            >
                {Object.entries(nationalities).map(([key, countryView], index: number) => {
                    const checked = countryView.code === currentNationality;

                    const hasSeparator = index < Object.entries(nationalities).length - 1;

                    return (
                        <div key={index} className={styles.item_wrapper}>
                            <DropDownItem onSelect={() => handleInputNationalityChange(countryView.code)} className={styles.item}>
                                <Font.OxaniumMedium className={styles.country_filter_option} mobile="12" desktop="14" as="span">
                                    <Flag isoCode={countryView.code} /> {countryView.name}
                                </Font.OxaniumMedium>
                                <label>
                                    <MixedCheckbox value={countryView.code} checked={true} />
                                    {checked && <Icon variant={IconsEnum.CHECKBOX} color="rgba(65, 80, 92,.8)" />}
                                    <VisuallyHidden> {key}</VisuallyHidden>
                                </label>
                            </DropDownItem>
                            {hasSeparator && <Separator color="rgba(65, 80, 92,.2)" spacing="0 auto" depth={`calc(100% - ${rem('15px')})`} />}
                        </div>
                    );
                })}
            </DropDown>
        </div>
    );
};

export default NationalityFilter;
